import { AptunoButton, Icon, Modal, SIZES, useResponsive, VARIANTS } from '@aptuno/aptuno-ui';
import { CardDescription, CardTitle, Image, ModalContent, ModalHeader, ModalTitle } from './EaseInModal.styled';

export const EaseInModalError = ({
  imageURl = null,
  isActive,
  title,
  onClose,
  onAcceptButtonClick,
  mainText,
  secondaryText,
  size = 600,
  btnText = 'Aceptar',
}) => {
  const { isMobile } = useResponsive();

  return (
    <Modal
      isModalBottom={isMobile}
      header={
        <ModalHeader>
          <Icon width={'30px'} height={'30px'} icon="minus" />
          <ModalTitle>{title || 'Ooops!!!'}</ModalTitle>
        </ModalHeader>
      }
      size={size}
      isActive={isActive}
      onClose={onClose}
    >
      <ModalContent>
        {imageURl && <Image src={imageURl} alt={'Modal Image'} />}
        <CardTitle>{mainText || 'Ooops!!!'}</CardTitle>
        <CardDescription>{secondaryText}</CardDescription>
        <AptunoButton appearance={VARIANTS.PRIMARY} size={SIZES.BIGGEST} onClick={onAcceptButtonClick}>
          {btnText}
        </AptunoButton>
      </ModalContent>
    </Modal>
  );
};
